import React from 'react';
import RequisitionsReportsListItem from './RequisitionsReportsListItem';
import { useTranslation } from 'react-i18next';

const RequisitionsReportsList = ({ data, warehouses }) => {
  const [t] = useTranslation('global');
  return (
    <div className='m-5 rounded-lg bg-white border border-gray-200 sticky top-0 z-10'>
      <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-white font-bold text-[#251658] text-sm rounded-t-2xl justify-between items-center border-b py-4">
        <div className="text-center col-span-1">#</div>
        <div className="text-center col-span-2">{t("reports.Permission_Number")}</div>
        <div className="text-center col-span-2">{t("reports.Permission_Type")}</div>
        <div className="text-center col-span-3">{t("reports.Warehouse")}</div>
        <div className="text-center col-span-2">{t("reports.Number_of_Products")}</div>
        <div className="text-center col-span-2">{t("reports.Date")}</div>
      </div>
      <div className='h-[calc(100vh-500px)] overflow-y-scroll custom-scrollbar'>

      {data.data.map((item, index) => (
        <RequisitionsReportsListItem key={item.id} item={item} warehouses={warehouses} index={index} />
      ))}
    </div>
    </div>
  );
};

export default RequisitionsReportsList;
